export default [
      {
        path: 'clientes',
        name: 'pos.clientes',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/components/shared/clientes/ClientesIndex.vue'),

    },
        {

        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: 'clientes/nuevo',

        name: 'pos.cliente.nuevo',
        component: () => import(/* webpackChunkName: "about" */ '@/components/shared/clientes/ClienteCreate.vue'),
        meta: { requireModuloCliente: true }



    },
    {


        path: 'clientes/:id_cliente',
        component: () => import(/* webpackChunkName: "about" */ '@/components/shared/clientes/ClienteLayout.vue'),
        meta: { requireModuloCliente: true },

        children: [
            // UserHome will be rendered inside User's <router-view>
            // when /user/:id is matched
            {
                path: '',
                name: 'pos.cliente.profile',
                component: () => import(/* webpackChunkName: "about" */ '@/components/shared/clientes/ClienteProfile.vue'),
            },
            {
                path: 'editar',
                name: 'pos.cliente.editar',
                component: () => import(/* webpackChunkName: "about" */ '@/components/shared/clientes/ClienteUpdate.vue'),
            },
            {
                path: 'direcciones',
                name: 'pos.cliente.direcciones',
                component: () => import(/* webpackChunkName: "about" */ '@/components/shared/clientes/direcciones/ClienteDirecciones.vue'),
            },
            {
                path: 'contabilidad',
                name: 'pos.cliente.contabilidad',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ '@/components/shared/clientes/contabilidad/ClienteContabilidad.vue'),
            },
            {
                path: 'cuentacorriente',
                name: 'pos.cliente.cuentacorriente',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ '@/components/shared/clientes/cuentacorriente/ClienteCuentaCorriente.vue'),
            },
            
            {
                path: 'cuentacorriente/settings',
                name: 'pos.cliente.cuentacorriente.settings',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ '@/components/shared/clientes/cuentacorriente/ClienteCuentaCorrienteSettings.vue'),
            },
            {
                path: 'cuentacorriente/actividad',
                name: 'pos.cliente.cuentacorriente.movimientos',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ '@/components/shared/clientes/cuentacorriente/ClienteCuentaCorrienteMovimientos.vue'),
            },
            {
                path: 'cuentacorriente/actividad/detail/:movimiento_id',
                name: 'pos.cliente.cuentacorriente.movimientos.detail',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ '@/components/shared/clientes/cuentacorriente/ClienteCuentaCorrienteMovimientosDetail.vue'),
            }
            // ...other sub routes
        ],
        meta: { requiresAuth: true, requireArqueoCaja: true, requireCaja: true, requireSucursal: true, requireModuloCliente: true }




    },
]
